export default "__VITE_ASSET__Dfutvv_g__"